import React, { ReactNode, useEffect } from 'react';
import { CloseIcon } from './Icons';

export interface SlideOutDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  position?: 'left' | 'right';
  width?: string;
  closeOnOverlayClick?: boolean;
  showCloseButton?: boolean;
}

export const SlideOutDrawer: React.FC<SlideOutDrawerProps> = ({
  isOpen,
  onClose,
  children,
  position = 'left',
  width = '70%',
  closeOnOverlayClick = true,
  showCloseButton = true,
}) => {
  // Lock body scroll when drawer is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex">
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={closeOnOverlayClick ? onClose : undefined}
        aria-hidden="true"
      />

      {/* Drawer */}
      <div
        className={`
          relative flex flex-col bg-base-200 shadow-xl
          transition-transform duration-300 ease-in-out
          ${position === 'left' ? 'mr-auto' : 'ml-auto'}
          ${isOpen ? 'translate-x-0' : position === 'left' ? '-translate-x-full' : 'translate-x-full'}
        `}
        style={{ width, maxWidth: '100vw' }}
      >
        {/* Close button */}
        {showCloseButton && (
          <button
            onClick={onClose}
            className="absolute top-4 right-4 btn btn-ghost btn-circle btn-sm"
            aria-label="Close drawer"
          >
            <CloseIcon className="h-5 w-5" />
          </button>
        )}

        {/* Content */}
        <div className="flex-1 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
};
